export default "debd10e57fb07dd2.ttf"